import { useQuery } from 'react-query';
import { OfferRequisitionService } from '../../../services/v1/applicant_tracking/OfferRequisitionService';

export const useOfferRequisition = (id: number, expand?: string[]) => {
  return useQuery({
    queryKey: ['offer_requisition', id, expand?.join(',')],
    queryFn: async () => {
      const params = {
        id: id.toString(),
        expand: expand,
      };
      return await OfferRequisitionService.show(params);
    },
  });
};
